import { type Components, type Theme } from "@mui/material/styles";

export const timeline: Components<Theme>["MuiTimeline"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: 0,
      // On mobile the timeline collapses to a single centered column:
      // the status chip sits above the date/time and the connector line
      // runs between items (no dot), per the mobile design.
      [theme.breakpoints.down("sm")]: {
        ".MuiTimelineItem-root": {
          flexDirection: "column",
          alignItems: "center",
          minHeight: "auto",
          "&::before": { display: "none" },
        },
        ".MuiTimelineOppositeContent-root": {
          order: 0,
          flex: "none",
          alignSelf: "center",
          margin: 0,
          padding: 0,
        },
        ".MuiTimelineContent-root": {
          order: 1,
          flex: "none",
          padding: theme.spacing(0.5, 0, 0),
          textAlign: "center",
        },
        ".MuiTimelineSeparator-root": {
          order: 2,
        },
        ".MuiTimelineDot-root": {
          display: "none",
        },
        ".MuiTimelineConnector-root": {
          width: "2px",
          flexGrow: 0,
          height: theme.spacing(3),
          margin: theme.spacing(1, 0),
        },
      },
    }),
  },
};
